import { connect } from 'react-redux';
import Component from './component';
import getPortalAlertAction from '../../actions/adminportalalert/get';

const mapStateToProps = (state) => ({
  session: state.session.get('data'),
  contactidroute: state.contacts.get('contactidroute'),
  portalAlert: state.adminportalalert.data,
});

const mapDispatchToProps = (dispatch) => ({
  getPortalAlert: () => {
    dispatch(getPortalAlertAction());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
